import { render, staticRenderFns } from "./Segment.vue?vue&type=template&id=4f5a6ea4&"
import script from "./Segment.vue?vue&type=script&lang=js&"
export * from "./Segment.vue?vue&type=script&lang=js&"
import style0 from "./Segment.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports